import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getAvailableDebtorsForCharges = async ({
    token,
    company_id
}) => {

    const params = {
        company_id
    }

    try {
        const res = await axiosCreate.get('/charge/debtor/tree', {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}